export const EVENTS_URL_PARAMS_CATEGORY = 'events';

export const ADVANCED_URL_PARAMS_CATEGORY = 'advancedEvents';

export const ADVANCED_EVENTS_LEVEL = 'DEBUG';

export const NCAP_MASTER_SLAVE_REGEX =
  /\s*\((?:[Mm]aster_pvd|[Ss]lave\d*_pvd)\)/;
